import { MarkerType } from "@xyflow/react";

export const FOLDERS = [
  { id: "inbox", label: "Inbox", icon: "InboxIcon", count: 5 },
  { id: "sent", label: "Sent", icon: "PaperAirplaneIcon", count: 0 },
  { id: "drafts", label: "Drafts", icon: "PencilSquareIcon", count: 2 },
  { id: "trash", label: "Trash", icon: "TrashIcon", count: 1 },
  { id: "spam", label: "Spam", icon: "ExclamationTriangleIcon", count: 1 },
];

const EDGE_STYLE = {
  type: "smoothstep",
  markerEnd: {
    type: MarkerType.Arrow,
    width: 15,
    height: 15,
    color: "#9ca3af",
  },
  style: {
    strokeWidth: 2,
    stroke: "#9ca3af",
  },
};

function edge(id, source, target, label) {
  return {
    id,
    source,
    target,
    ...EDGE_STYLE,
    ...(label
      ? {
          label,
          labelStyle: { fill: "#4b5563", fontWeight: 600, fontSize: 11 },
          labelBgPadding: [8, 4],
          labelBgBorderRadius: 6,
          labelBgStyle: {
            fill: "#ffffff",
            stroke: "#e5e7eb",
            strokeWidth: 1,
          },
        }
      : {}),
  };
}

export const WORKFLOWS = {
  "wf-1": {
    title: "Campaign Report Distribution",
    nodes: [
      {
        id: "t1",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 0 },
        data: {
          label: "Email Received",
          description: "Q3 campaign report arrives from Sarah",
          nodeType: "trigger",
        },
      },
      {
        id: "a1",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 150 },
        data: {
          label: "Extract Attachments",
          description: "Parse PDF report from email",
          nodeType: "action",
        },
      },
      {
        id: "a2",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 300 },
        data: {
          label: "Update Dashboard",
          description: "Sync metrics to analytics dashboard",
          nodeType: "action",
        },
      },
      {
        id: "a3",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 450 },
        data: {
          label: "Notify Marketing Team",
          description: "Send Slack notification to #marketing",
          nodeType: "action",
        },
      },
    ],
    edges: [edge("e1", "t1", "a1"), edge("e2", "a1", "a2"), edge("e3", "a2", "a3")],
  },

  "wf-2": {
    title: "Server Alert Escalation",
    nodes: [
      {
        id: "t1",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 0 },
        data: {
          label: "Alert Triggered",
          description: "CPU threshold exceeded on prod-web-03",
          nodeType: "trigger",
        },
      },
      {
        id: "a1",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 150 },
        data: {
          label: "Check Severity",
          description: "Evaluate alert severity level",
          nodeType: "condition",
        },
      },
      {
        id: "a2",
        type: "inboxWorkflowNode",
        position: { x: -150, y: 300 },
        data: {
          label: "Page On-Call Engineer",
          description: "Critical: send PagerDuty alert",
          nodeType: "action",
        },
      },
      {
        id: "a3",
        type: "inboxWorkflowNode",
        position: { x: 150, y: 300 },
        data: {
          label: "Log & Monitor",
          description: "Low: log event and continue monitoring",
          nodeType: "action",
        },
      },
    ],
    edges: [
      edge("e1", "t1", "a1"),
      edge("e2", "a1", "a2", "Critical"),
      edge("e3", "a1", "a3", "Low"),
    ],
  },

  "wf-3": {
    title: "Partnership Review Pipeline",
    nodes: [
      {
        id: "t1",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 0 },
        data: {
          label: "Proposal Received",
          description: "New partnership email detected",
          nodeType: "trigger",
        },
      },
      {
        id: "a1",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 150 },
        data: {
          label: "Add to CRM",
          description: "Create deal in Salesforce pipeline",
          nodeType: "action",
        },
      },
      {
        id: "a2",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 300 },
        data: {
          label: "Schedule Review",
          description: "Book meeting with BD team",
          nodeType: "action",
        },
      },
      {
        id: "a3",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 450 },
        data: {
          label: "Send Acknowledgment",
          description: "Auto-reply confirming receipt",
          nodeType: "action",
        },
      },
      {
        id: "a4",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 600 },
        data: {
          label: "Wait 48 Hours",
          description: "Allow time for internal review",
          nodeType: "delay",
        },
      },
    ],
    edges: [
      edge("e1", "t1", "a1"),
      edge("e2", "a1", "a2"),
      edge("e3", "a2", "a3"),
      edge("e4", "a3", "a4"),
    ],
  },

  "wf-4": {
    title: "Sprint Task Tracker",
    nodes: [
      {
        id: "t1",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 0 },
        data: {
          label: "Jira Notification",
          description: "New tasks assigned in Sprint 14",
          nodeType: "trigger",
        },
      },
      {
        id: "a1",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 150 },
        data: {
          label: "Update Task Board",
          description: "Sync to personal Kanban board",
          nodeType: "action",
        },
      },
    ],
    edges: [edge("e1", "t1", "a1")],
  },

  "wf-5": {
    title: "Draft Auto-Save Pipeline",
    nodes: [
      {
        id: "t1",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 0 },
        data: {
          label: "Draft Created",
          description: "New email draft saved",
          nodeType: "trigger",
        },
      },
      {
        id: "a1",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 150 },
        data: {
          label: "Auto-Save",
          description: "Save draft every 30 seconds",
          nodeType: "action",
        },
      },
      {
        id: "a2",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 300 },
        data: {
          label: "Schedule Send",
          description: "Queue for optimal send time",
          nodeType: "delay",
        },
      },
    ],
    edges: [edge("e1", "t1", "a1"), edge("e2", "a1", "a2")],
  },

  "wf-6": {
    title: "Spam Detection Flow",
    nodes: [
      {
        id: "t1",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 0 },
        data: {
          label: "Spam Detected",
          description: "Email flagged by spam filter",
          nodeType: "trigger",
        },
      },
      {
        id: "a1",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 150 },
        data: {
          label: "Flag & Quarantine",
          description: "Mark as spam, isolate from inbox",
          nodeType: "action",
        },
      },
      {
        id: "a2",
        type: "inboxWorkflowNode",
        position: { x: 0, y: 300 },
        data: {
          label: "Block Sender",
          description: "Add sender to blocklist",
          nodeType: "action",
        },
      },
    ],
    edges: [edge("e1", "t1", "a1"), edge("e2", "a1", "a2")],
  },
};

export const EMAILS = [
  {
    id: "email-1",
    folder: "inbox",
    from: { name: "Sarah Chen", email: "sarah@acme.com" },
    subject: "Q3 Campaign Performance Report",
    preview:
      "Hi team, attached is the Q3 campaign performance report with all the metrics we discussed in last week's meeting...",
    date: "2026-03-08T09:30:00Z",
    read: false,
    workflowId: "wf-1",
  },
  {
    id: "email-2",
    folder: "inbox",
    from: { name: "DevOps Bot", email: "alerts@infra.internal" },
    subject: "Server Alert: CPU Threshold Exceeded",
    preview:
      "ALERT: prod-web-03 CPU usage at 94% for the last 15 minutes. Automatic scaling has been triggered...",
    date: "2026-03-08T08:15:00Z",
    read: false,
    workflowId: "wf-2",
  },
  {
    id: "email-3",
    folder: "inbox",
    from: { name: "Marcus Johnson", email: "marcus@partnerco.io" },
    subject: "New Partnership Proposal - Q4 Integration",
    preview:
      "Dear team, we'd like to propose a strategic partnership for Q4 involving a joint product integration...",
    date: "2026-03-07T16:45:00Z",
    read: true,
    workflowId: "wf-3",
  },
  {
    id: "email-4",
    folder: "inbox",
    from: { name: "Jira Notifications", email: "noreply@jira.atlassian.com" },
    subject: "[FLUVO-342] Sprint 14 tasks assigned to you",
    preview:
      "You have 4 new tasks assigned in Sprint 14: FLUVO-342 Implement inbox view, FLUVO-343 Add workflow panel...",
    date: "2026-03-07T10:00:00Z",
    read: true,
    workflowId: "wf-4",
  },
  {
    id: "email-5",
    folder: "inbox",
    from: { name: "Lisa Wang", email: "lisa@acme.com" },
    subject: "Design Review Meeting Notes",
    preview:
      "Hey everyone, here are the notes from today's design review. We discussed the new inbox layout and workflow...",
    date: "2026-03-06T14:20:00Z",
    read: false,
    workflowId: "wf-3",
  },
  {
    id: "email-6",
    folder: "drafts",
    from: { name: "You", email: "me@fluvo.ai" },
    subject: "Re: Budget Allocation for Q4",
    preview:
      "Thanks for sending over the budget breakdown. I've reviewed the numbers and have a few suggestions...",
    date: "2026-03-08T07:00:00Z",
    read: true,
    workflowId: "wf-5",
  },
  {
    id: "email-7",
    folder: "drafts",
    from: { name: "You", email: "me@fluvo.ai" },
    subject: "Weekly Team Update - March 8",
    preview:
      "Hi team, here's the weekly update: 1) Inbox page is in progress 2) Workflow panel integration complete...",
    date: "2026-03-07T22:00:00Z",
    read: true,
    workflowId: "wf-5",
  },
  {
    id: "email-8",
    folder: "trash",
    from: { name: "Newsletter Bot", email: "news@techdigest.com" },
    subject: "Your Weekly Tech Digest",
    preview:
      "This week in tech: AI assistants continue to reshape productivity workflows across enterprise...",
    date: "2026-03-05T08:00:00Z",
    read: true,
    workflowId: "wf-4",
  },
  {
    id: "email-9",
    folder: "spam",
    from: { name: "Prize Winner", email: "winner@totallyfake.com" },
    subject: "Congratulations! You have won a $500 gift card!",
    preview:
      "Click here to claim your prize! This is a limited time offer and you must act now before it expires...",
    date: "2026-03-04T03:00:00Z",
    read: true,
    workflowId: "wf-6",
  },
];
